import { Input, Select } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { getExpectNumber } from '../../../../../common'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { FuelTypeEnum, FuelUnitEnum } from '../../../../../models'
import { RootState } from '../../../../../stores'
import { setFuelFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
  display: flex;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 3px 10px;
  background-color: #fafafa;
  display: inline-flex;
`

export const SearchFuelDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { fuelFilter } = useSelector((state: RootState) => state.fuel)
  const [filter, setFilter] = React.useState(fuelFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('fuel.name', language)}
          addonBefore={translate('fuel.name', language)}
          value={filter.name}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              name: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate(`common.price.from`, language)}
          addonBefore={translate(`common.price.from`, language)}
          value={filter.priceFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              priceFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate(`common.price.to`, language)}
          addonBefore={translate(`common.price.to`, language)}
          value={filter.priceTo}
          type="number"
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              priceTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate(`fuel.unit`, language)}:</StyledLabel>
        <Select
          mode="multiple"
          maxTagCount="responsive"
          value={filter.units}
          style={{
            flex: 1,
          }}
          onChange={(e) =>
            setFilter({
              ...filter,
              units: e || Object.values(FuelUnitEnum),
            })
          }
        >
          {Object.values(FuelUnitEnum).map((item) => (
            <Select.Option value={item} key={item}>
              {translate(`fuel.unit.${item.toLowerCase()}`, language)}
            </Select.Option>
          ))}
        </Select>
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate(`fuel.type`, language)}:</StyledLabel>
        <Select
          mode="multiple"
          maxTagCount="responsive"
          value={filter.types}
          style={{
            flex: 1,
          }}
          onChange={(e) =>
            setFilter({
              ...filter,
              types: e || Object.values(FuelTypeEnum),
            })
          }
        >
          {Object.values(FuelTypeEnum).map((item) => (
            <Select.Option value={item} key={item}>
              {translate(`fuel.type.${item.toLowerCase()}`, language)}
            </Select.Option>
          ))}
        </Select>
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() =>
        dispatch(
          setFuelFilter({
            ...filter,
            priceFrom: getExpectNumber(true, filter.priceFrom, filter.priceTo),
            priceTo: getExpectNumber(false, filter.priceFrom, filter.priceTo),
          })
        )
      }
    />
  )
}
